import { createContext } from 'react';

import { IInventoryConfig } from '@shared/types/inventory_config';

export const CategoriesContext = createContext<IInventoryConfig | undefined>(undefined);
